import create from 'zustand';

type Theme = 'light' | 'dark' | 'system';

interface UIStore {
  currentTheme: Theme;
  overrideTheme: Theme | null;
  isSiderCollapsed: boolean;
  isUserModalVisible: boolean;
  isGlobalLoading: boolean;
  setTheme: (theme: Theme) => void;
  setOverrideTheme: (theme: Theme | null) => void;
  toggleSider: (collapsed: boolean) => void;
  showUserModal: () => void;
  closeUserModal: () => void;
  showGlobalLoadingDimmer: () => void;
  hideGlobalLoadingDimmer: () => void;
}

const useUIStore = create<UIStore>((set) => ({
  // States
  currentTheme: 'light',
  overrideTheme: null,
  isSiderCollapsed: false,
  isUserModalVisible: false,
  isGlobalLoading: false,

  // Setters
  setTheme(theme) {
    set({ currentTheme: theme });
  },
  setOverrideTheme(theme) {
    set({ overrideTheme: theme });
  },
  toggleSider(collapsed) {
    set({ isSiderCollapsed: collapsed });
  },
  showUserModal() {
    set({ isUserModalVisible: true });
  },
  closeUserModal() {
    set({ isUserModalVisible: false });
  },
  showGlobalLoadingDimmer() {
    set({ isGlobalLoading: true });
  },
  hideGlobalLoadingDimmer() {
    set({ isGlobalLoading: false });
  },
}));

export { useUIStore };
